import { PersonMapping } from '@bp/shared-planung-utils';
import { t } from 'i18next';

export const getPersonMappingLabel = (option: PersonMapping): string => {
  switch (option) {
    case 'active':
      return t('common.active', { context: 'long' });
    case 'birthday':
      return t('persons.birthday');
    case 'callingName':
      return t('persons.callingName');
    case 'email':
      return t('common.email');
    case 'firstName':
      return t('common.firstName');
    case 'gender':
      return t('common.gender');
    case 'lastName':
      return t('common.lastName');
    case 'prefixName':
      return t('common.prefixName');
    case 'salutation':
      return t('common.salutation');
    case 'shortName':
      return t('common.shortName');
    case 'roles':
      return t('role.title', { count: 1 });
    case 'personalId':
      return t('persons.personalId');
    case 'foreignId':
      return t('common.uuid');
    default:
      return option;
  }
};
